"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CstCleanupVisitor = void 0;
const tree_1 = require("../custom_tree/base/tree");
class CstCleanupVisitor {
    ast;
    visitProgram(ctx) {
        this.ast = new tree_1.Tree();
        ctx.children?.pop();
        return this.visitChildren(ctx);
    }
    visit(tree) {
        return tree;
    }
    visitChildren(ctx) {
        // Visit each child node in the order they appear
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        for (let i = 0; i < ctx.children?.length ?? 0; i++) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            const child = ctx.getChild(i);
            child.accept(this);
        }
        return ctx;
    }
    visitExprParenthesis(ctx) {
        return this.visitChildren(ctx);
    }
    visitExprPow(ctx) {
        return this.visitChildren(ctx);
    }
    visitExprTimesDiv(ctx) {
        return this.visitChildren(ctx);
    }
    visitExprPlusMinus(ctx) {
        return this.visitChildren(ctx);
    }
    visitExprComparison(ctx) {
        return this.visitChildren(ctx);
    }
    visitExprBoolean(ctx) {
        return this.visitChildren(ctx);
    }
    visitExprAtom(ctx) {
        const parent = ctx.parentCtx;
        const singleChild = ctx.children?.[0];
        if (!singleChild)
            return this.visitChildren(ctx);
        if (!parent?.children)
            return this.visitChildren(ctx);
        parent.children[parent.children.indexOf(ctx)] = singleChild;
        singleChild.parentCtx = parent;
        return this.visitChildren(ctx);
    }
    visitExprSignedAtom(ctx) {
        return this.visitChildren(ctx);
    }
    visitTerminal(ctx) {
        return ctx;
    }
    visitErrorNode(ctx) {
        return ctx;
    }
    visitFormula(ctx) {
        return this.visitChildren(ctx);
    }
    visitExpr(ctx) {
        return this.visitChildren(ctx);
    }
    visitAtom(ctx) {
        const parent = ctx.parentCtx;
        const singleChild = ctx.children?.[0];
        if (!singleChild)
            return this.visitChildren(ctx);
        if (!parent?.children)
            return this.visitChildren(ctx);
        parent.children[parent.children.indexOf(ctx)] = singleChild;
        singleChild.parentCtx = parent;
        return this.visitChildren(ctx);
    }
}
exports.CstCleanupVisitor = CstCleanupVisitor;
